var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      staticClass: "editarInfoStreamax",
      attrs: { row: "", "justify-center": "" }
    },
    [
      _c("v-card", { attrs: { id: "cardDivTV" } }, [
        _c("div", [
          _c(
            "div",
            { staticClass: "cardnew", attrs: { align: "center" } },
            [
              _c("br"),
              _c(
                "v-flex",
                { attrs: { md10: "" } },
                [
                  _c(
                    "v-card",
                    { staticClass: "rounded-card" },
                    [
                      _c(
                        "v-form",
                        {
                          ref: "form",
                          staticClass: "col-md-12",
                          attrs: { "lazy-validation": "" },
                          model: {
                            value: _vm.validForm,
                            callback: function($$v) {
                              _vm.validForm = $$v
                            },
                            expression: "validForm"
                          }
                        },
                        [
                          _c(
                            "v-container",
                            { attrs: { "grid-list-md": "" } },
                            [
                              _c(
                                "div",
                                { attrs: { align: "left" } },
                                [
                                  _c("v-flex", { attrs: { md12: "" } }, [
                                    _c(
                                      "h2",
                                      {
                                        staticClass: "h2_title",
                                        staticStyle: {
                                          "margin-top": "12px !important"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.esEdicion
                                                ? "Editar Server 3"
                                                : "Ver Detalle Server 3"
                                            ) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  ])
                                ],
                                1
                              ),
                              _c("v-divider"),
                              _c("br"),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm10: "",
                                        md10: "",
                                        lg10: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-checkbox", {
                                        attrs: {
                                          label: _vm.formFields.enable.label,
                                          disabled: true
                                        },
                                        model: {
                                          value: _vm.formFields.enable.check,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.enable,
                                              "check",
                                              $$v
                                            )
                                          },
                                          expression: "formFields.enable.check"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm10: "",
                                        md10: "",
                                        lg10: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label:
                                            _vm.formFields.protocolType.label,
                                          items:
                                            _vm.formFields.protocolType.items,
                                          "item-text": "label",
                                          "item-value": "id",
                                          value: _vm.selectedProtocolType,
                                          "return-object": "",
                                          disabled: true
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.protocolType.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.protocolType,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.protocolType.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm10: "",
                                        md10: "",
                                        lg10: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label:
                                            _vm.formFields.enableNetwork.label,
                                          items:
                                            _vm.formFields.enableNetwork.items,
                                          "item-text": "label",
                                          "item-value": "id",
                                          value: _vm.selectedEnableNetwork,
                                          "return-object": "",
                                          disabled: true
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.enableNetwork.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.enableNetwork,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.enableNetwork.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm10: "",
                                        md10: "",
                                        lg10: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label:
                                            _vm.formFields.registerServerIp
                                              .label,
                                          disabled: true,
                                          variant: "plain"
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.registerServerIp
                                              .value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.registerServerIp,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.registerServerIp.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm10: "",
                                        md10: "",
                                        lg10: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("p1", { staticClass: "h2_title" }, [
                                        _vm._v("Register Server Port")
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm8: "",
                                        md8: "",
                                        lg8: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: _vm.formFields.tcp.label,
                                          disabled: true,
                                          variant: "plain"
                                        },
                                        model: {
                                          value: _vm.formFields.tcp.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.tcp,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression: "formFields.tcp.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm8: "",
                                        md8: "",
                                        lg8: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: _vm.formFields.udp.label,
                                          disabled: true,
                                          variant: "plain"
                                        },
                                        model: {
                                          value: _vm.formFields.udp.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.udp,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression: "formFields.udp.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm10: "",
                                        md10: "",
                                        lg10: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label:
                                            _vm.formFields.mediaServerIp.label,
                                          disabled: true,
                                          variant: "plain"
                                        },
                                        model: {
                                          value:
                                            _vm.formFields.mediaServerIp.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.mediaServerIp,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.mediaServerIp.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm10: "",
                                        md10: "",
                                        lg10: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("p1", { staticClass: "h2_title" }, [
                                        _vm._v("Media Server Port")
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm8: "",
                                        md8: "",
                                        lg8: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: _vm.formFields.tcpMedia.label,
                                          disabled: true,
                                          variant: "plain"
                                        },
                                        model: {
                                          value: _vm.formFields.tcpMedia.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.tcpMedia,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.tcpMedia.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-layout",
                                { attrs: { "justify-center": "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      attrs: {
                                        sm8: "",
                                        md8: "",
                                        lg8: "",
                                        "d-flex": ""
                                      }
                                    },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: _vm.formFields.udpMedia.label,
                                          disabled: true,
                                          variant: "plain"
                                        },
                                        model: {
                                          value: _vm.formFields.udpMedia.value,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.formFields.udpMedia,
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "formFields.udpMedia.value"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }